module.exports = __webpack_public_path__ + "static/img/2126_phase_function_Paper_PointsHejduk_Prediction.8ddab71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2126_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yXkV
// module chunks = 0